import { createSlice } from '@reduxjs/toolkit';
import { getActivityStatusList } from './thunk';

const getOptionLabel = item => item?.name || item?.label || item?.description || item?._id || '';

export const initialState = {
    activityStatusList: [],
    activityStatusListSelect: [],
    isLoadingList: false,
    isSuccess: false,
};

const ActivityStatusSlice = createSlice({
    name: 'ActivityStatus',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getActivityStatusList.pending, state => {
            state.isLoadingList = true;
            state.isSuccess = false;
        });
        builder.addCase(getActivityStatusList.fulfilled, (state, action) => {
            const list = action.payload || [];
            state.activityStatusList = list;
            state.activityStatusListSelect = list.map(item => ({
                item,
                value: item._id,
                label: getOptionLabel(item),
            }));
            state.isLoadingList = false;
            state.isSuccess = true;
        });
        builder.addCase(getActivityStatusList.rejected, (state, action) => {
            state.error = action.payload || null;
            state.isLoadingList = false;
            state.isSuccess = false;
        });
    },
});

export default ActivityStatusSlice.reducer;
